<template>
  <div class="dict">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ this.$t('financeSalesInvoice.title.invoice') }}</div
          >
        </template>
        <div class="collapse-content">
          <InvoiceInfo
            :canEdit="canEdit"
            :currencyList="currencyList"
            @updateInvoice="updateInvoice"
            @resetRowInfo="resetRowInfo"
            @setRateInfo="setRateInfo"
            @changeBusinessTypeHandler="changeBusinessTypeHandler"
            ref="invoiceInfo"
          />
        </div>
      </el-collapse-item>
      <!-- 客户开票信息 -->
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ this.$t('financeSalesInvoice.title.rate') }}</div
          >
        </template>
        <div class="collapse-content">
          <RateInfo
            :canEdit="canEdit"
            :invoiceInfo="invoiceInfo"
            :mobileList="mobileList"
            :emailList="emailList"
            ref="rateInfo"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="4">
        <el-tabs type="border-card" v-model="activeNameTab" class="addCooperationTabs">
          <el-tab-pane name="first" :label="$t('financeSalesInvoice.title.row')">
            <!-- 行信息 -->
            <RowInfo
              :canEdit="canEdit"
              :dictMap="dictMap"
              :invoiceInfo="invoiceInfo"
              :currencyList="currencyList"
              :validateInvoice="validateInvoice"
              :currentSettlementBusinessType="currentSettlementBusinessType"
              :isDisabledRowDeleteBtn="isDisabledRowDeleteBtn"
              @calTotal="calTotal"
              @setSettlement="setSettlementNo"
              @selectionChanged="selectionChanged"
              @deleteRowInfoHandler="deleteRowInfoHandler"
              @isTableDataHandler="isTableDataHandler"
              @clearStatementDetailTableHandler="clearStatementDetailTableHandler"
              @changeCurrentRowInfo="changeCurrentRowInfo"
              @changeRowDetail="changeRowDetail"
              ref="rowInfo"
            />
          </el-tab-pane>
          <el-tab-pane name="second" :label="$t('financeSalesInvoice.title.glodenRate')">
            <gloden-rate-info ref="glodenInfo" />
          </el-tab-pane>
          <!-- <el-tab-pane name="voucherTab" :label="$t('addInvoice.invoiceLine.title2')">
            <voucher
              ref="voucher"
              :voucherList="voucherList"
              @reverseInfo="reverseInfo"
              @postInfo="postInfo"
            ></voucher>
          </el-tab-pane> -->
        </el-tabs>
      </el-collapse-item>
      <!-- 只有城矿才出现的板块 -->
      <template>
        <el-collapse-item
          name="5"
          v-if="
            userInfo.businessGroup == '城矿' && (selectRowList.length || invoiceInfo.invoiceNum)
          "
        >
          <template slot="title">
            <div class="collapse-title-pre"><span></span>结算明细</div>
          </template>
          <div class="collapse-content">
            <StatementDetailTable
              :selectRowList="selectRowList"
              :invoiceNum="invoiceInfo.invoiceNum"
              :isDisabledBtn="isDisabledBtn"
              :clearStatementDetailTable="clearStatementDetailTable"
              @deleteRowHandler="deleteRowHandler"
              @isTableDataHandler="isTableDataHandler"
              ref="statementDetailTableRef"
            />
          </div>
        </el-collapse-item>
      </template>
      <!-- 多式联运开票行明细与物贸类似 -->
      <template>
        <el-collapse-item
          name="5"
          v-if="['物贸', '多式联运'].includes(userInfo.businessGroup) && currentRowInfo != {}"
        >
          <template slot="title">
            <div class="collapse-title-pre"><span></span>开票行明细</div>
          </template>
          <div class="collapse-content">
            <rowDetailTable
              :canEdit="canEdit"
              :invoiceInfo="invoiceInfo"
              :currentRowInfo="currentRowInfo"
              @rowDetailInsert="rowDetailInsert"
              @deleteRowDetail="deleteRowDetail"
              @updateRowDetail="updateRowDetail"
              ref="rowDetailTableRef"
            />
          </div>
        </el-collapse-item>
      </template>
      <el-collapse-item name="6">
        <template slot="title">
          <div class="collapse-title-pre"><span></span>附件</div>
        </template>
        <div class="collapse-content">
          <!--
              canEdit &&
              ['', 'saved', 'withdraw', 'returned'].indexOf(invoiceInfo.invoiceStatus) != -1 -->
          <!-- <upload
            ref="upload"
            :isShow="
              canEdit &&
              ['', 'saved', 'withdraw', 'returned'].indexOf(invoiceInfo.invoiceStatus) != -1
            "
            defaultPath="scm/saleInvoice"
            :tableData="attachmentList"
            @upload="uploadList"
          /> -->
          <!--
              canEdit &&
              ['', 'saved', 'withdraw', 'returned'].indexOf(invoiceInfo.invoiceStatus) != -1
             -->
          <FileTable
            ref="fileTableRef"
            :attachments="attachmentList"
            :isShowDownBtn="isShowDownBtn"
            :isShowSelectBtn="canEdit && userInfo.businessGroup == '物贸'"
            @viewContractFile="viewContractFile"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <el-button
        v-hasPermi="['2021050810464347662']"
        :disabled="
          (['saved', 'withdraw', 'returned'].indexOf(invoiceInfo.invoiceStatus) == -1 &&
            !canEdit) ||
          !invoiceInfo.invoiceStatus
        "
        type="primary"
        @click="edit"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('addInvoice.btns.edit') }}
      </el-button>
      <el-button
        v-hasPermi="['2021050810465983890']"
        :disabled="
          ['', 'saved', 'withdraw', 'returned'].indexOf(invoiceInfo.invoiceStatus) == -1 || !canEdit
        "
        type="primary"
        @click="save"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('addInvoice.btns.save') }}
      </el-button>
      <el-button
        v-hasPermi="['2021050810472658009']"
        :disabled="['', 'saved', 'withdraw', 'returned'].indexOf(invoiceInfo.invoiceStatus) == -1"
        type="primary"
        @click="submit(undefined)"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('addInvoice.btns.submission') }}
      </el-button>
      <el-button
        v-hasPermi="['2021050810473865155']"
        :disabled="['approved'].indexOf(invoiceInfo.invoiceStatus) == -1"
        type="primary"
        @click="withdraw"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('addInvoice.btns.withdraw') }}
      </el-button>
      <el-button
        v-hasPermi="['2021050810475085579']"
        :disabled="['submitted'].indexOf(invoiceInfo.invoiceStatus) == -1"
        type="primary"
        @click="returnRecords"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('addInvoice.btns.return') }}
      </el-button>
      <el-button
        v-hasPermi="['2021050810481118590']"
        :disabled="
          ['saved', 'withdraw', 'returned'].indexOf(invoiceInfo.invoiceStatus) == -1 ||
          this.$route.name == 'saleInvoiceAdd'
        "
        type="primary"
        @click="deleteRecord"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('addInvoice.btns.delete') }}
      </el-button>
      <el-button
        v-hasPermi="['2021071515193104394']"
        :disabled="['submitted', 'hold'].indexOf(invoiceInfo.invoiceStatus) == -1"
        type="primary"
        @click="print"
        :loading="load"
        class="fixed-bottom-btn"
        >打印
      </el-button>
      <el-button
        v-hasPermi="['2021050810482520659']"
        :disabled="
          ['submitted', 'hold'].indexOf(invoiceInfo.invoiceStatus) == -1 ||
          ['notgenerate', 'generated', 'postError'].indexOf(invoiceInfo.accountingStatus) == -1
        "
        type="primary"
        @click="handleAccountEntry"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('addInvoice.btns.accountEntry') }}
      </el-button>
      <el-button
        v-hasPermi="['2021050810483562067']"
        :disabled="
          ['submitted', 'hold'].indexOf(invoiceInfo.invoiceStatus) == -1 ||
          ['generated', 'postError'].indexOf(invoiceInfo.accountingStatus) == -1
        "
        type="primary"
        @click="doSyncVoucherForEntityData()"
        :loading="load"
        class="fixed-bottom-btn"
        >过账凭证
      </el-button>
      <el-button
        v-hasPermi="['2021050810484501666']"
        :disabled="['submitted'].indexOf(invoiceInfo.invoiceStatus) == -1"
        type="primary"
        @click="doReverseAccountEntry()"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('functionBtn.writeOff') }}
      </el-button>
      <el-button
        v-if="invoiceInfo.invoiceStatus == 'submitted'"
        type="primary"
        @click="withdrawApprovalHandler()"
        class="fixed-bottom-btn"
        >撤回审批
      </el-button>
    </div>
    <print-dialog ref="printDialog"></print-dialog>
    <SelectContractFileDialog
      ref="selectContractFileDialogRef"
      @confirm="confirm"
    ></SelectContractFileDialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import InvoiceInfo from './components/invoiceInfo';
  import RateInfo from './components/rateInfo';
  import GlodenRateInfo from './components/glodenRateInfo';
  import RowInfo from './components/rowInfo';
  import API from '@/api/financeCenter/saleInvoice';
  import supplierDeliveryOrderApi from '@/api/wareHouse/supplierDeliveryOrder.js';
  // import { delcommafy } from '@/common/js/util';
  // import BASE_API from '@/api/dataBase';
  import loading from '@/common/js/load.js'; //loading
  import voucherMixins from '@/common/mixins/voucher.js';
  import wmMinxins from './minxins/wuMinxins.js';
  import ORDER_API from '@/api/purchaseSalesCenter/purchaseSales.js';
  import printDialog from './components/printDialog';
  import XEUtils from 'xe-utils';
  import StatementDetailTable from './components/StatementDetailTable/index.vue';
  import rowDetailTable from './components/rowDetailTable/index.vue';
  import _ from 'loadsh';
  import SelectContractFileDialog from '@/components/business/SelectContractFileDialog/index.vue';
  // import Upload from '@/components/upload';
  export default {
    mixins: [voucherMixins, wmMinxins],
    components: {
      InvoiceInfo,
      RateInfo,
      GlodenRateInfo,
      RowInfo,
      printDialog,
      StatementDetailTable,
      rowDetailTable,
      // Upload,
      SelectContractFileDialog,
    },
    name: 'addInvoice',
    data() {
      // const date = XEUtils.toDateString(new Date(), 'yyyy-MM-dd');
      return {
        attachmentList: [],
        activeNameTab: 'first',
        voucherList: [], //凭证列表
        load: false,
        // activeNames: ['1','2','3','4','5','6'],//默认展开那些面板，
        activeNames: ['1', '2', '4', '5', '6'],
        type: false,
        canEdit: this.$route.query.isEdit == 'Y',
        taxRateList: [], //率
        companyTree: [], // 部门数
        menuButtonList: [],
        payList: [], //付款信息
        defaultVisible: false, //匹配采购合同
        checkRowKeys: [],
        invoiceInfo: {
          invoiceStatus: '',
          invoiceCompanyCode: '',
        }, //发票信息
        dictMap: {
          reverseFlagOptions: [],
          unitOptions: [],
        }, //字典
        belongDate: '',
        voucherFlag: 'AE_AR_INVOICES', //凭证标识
        isHnFlag: false,
        currentSettlementBusinessType: '',
        mobileList: [],
        emailList: [],
        selectRowList: [], // 选中的结算行
        clearStatementDetailTable: false,
        isDisabledRowDeleteBtn: true,
        rowInfoTableData: [], // 行新数据
        currentRowInfo: {}, //物贸  当前行信息
      };
    },
    computed: {
      ...mapState({
        stateDictList(state) {
          if (state.dict.dictList.length > 10) {
            this.dictMap.reverseFlagOptions = state.dict.dictList.find(
              (it) => it.dictType == 'reverseFlag'
            ).dictList;
            this.dictMap.unitOptions = state.dict.dictList.find(
              (it) => it.dictType == 'basic_unit'
            ).dictList;
            this.$forceUpdate();
          }
        },
        currencyList() {
          return this.$baseRequest.getDictListMapByType('all_currency');
        },
      }),
      isDisabledBtn() {
        return (
          ['', 'saved', 'withdraw', 'returned'].indexOf(this.invoiceInfo.invoiceStatus) == -1 ||
          !this.canEdit
        );
      },
      isShowDownBtn() {
        return !(
          this.canEdit &&
          ['', 'saved', 'withdraw', 'returned'].indexOf(this.invoiceInfo.invoiceStatus) != -1
        );
      },
    },
    watch: {
      stateDictList(newV) {
        if (newV.length > 10) {
          this.dictMap.reverseFlagOptions = newV.find(
            (it) => it.dictType == 'reverseFlag'
          ).dictList;
          this.$forceUpdate();
        }
      },
    },
    mounted() {
      console.log(this.$route, this.$router, '路由');
      //制单人默认
      const date = XEUtils.toDateString(new Date(), 'yyyy-MM-dd');
      this.invoiceInfo.invoiceCreatePersonCode = this.userInfo.userCode;
      this.invoiceInfo.invoiceCreatePersonName = this.userInfo.userName;
      this.invoiceInfo.invoiceCreateDate = date;
      this.invoiceInfo.exchangeDate = date;
      this.invoiceInfo.belongDate = date;
      this.invoiceInfo.invoiceSource = '3';
      this.invoiceInfo.invoiceType = 'invoice';
      this.invoiceInfo.expenseTypeCode = '01';
      // 给发票信息赋值
      this.$refs.invoiceInfo.formData = Object.assign(
        this.$refs.invoiceInfo.formData,
        this.invoiceInfo
      );
      this.isDisabledRowDeleteBtn = false;
      const query = this.$route.query;
      const params = this.$route.params;
      console.log(JSON.stringify(params), '开票申请跳转过来');
      // console.log("aa",params.returnAttachmentList)
      if (params)
        (this.attachmentList = params.returnAttachmentList || []),
          (this.invoiceInfo.id = query['id']);
      if (
        this.invoiceInfo.id ||
        (query.ladingNo && !this.invoiceInfo.id) ||
        (query.returnNo && !this.invoiceInfo.id) ||
        (query.contractNo && !this.invoiceInfo.id)
      ) {
        this.getDetail();
      } else {
        // 新增情况下需监听字段变化
        this.$refs.invoiceInfo.initFlag = false;
        if (!this.$utils.isEmpty(params)) {
          this.invoiceInfo = { ...this.invoiceInfo, ...params };
          this.$refs.invoiceInfo.getDetail(this.invoiceInfo);
          if (this.invoiceInfo.businessType == '02' && this.$route.name == 'saleInvoiceAdd') {
            params.goldenTaxType = '08xdp';
          }
          if (this.invoiceInfo.businessType == '01' && this.$route.name == 'saleInvoiceAdd') {
            params.goldenTaxType = '';
          }
          console.log('kk', params.goldenTaxType);
          this.currentSettlementBusinessType = params.businessType;
          // 单独处理个人的时候
          let newObj = {};
          this.getAllMobileAndEmail(params.partnerCode, params.invoiceDepartmentNo)
            .then(() => {
              newObj['partnerEmail'] = params.partnerEmail || '';
              newObj['mobilePhone'] = params.mobilePhone || '';
              newObj['ifPersonalPartner'] = params.invoiceProperty || '';
              newObj['invoiceProperty'] = params.invoiceProperty; // 是否为个人1是个人0是企业
              this.$refs.rateInfo.setInit({ ...params, ...newObj });
            })
            .catch(() => {
              if (this.invoiceInfo.businessType == '02' && this.$route.name == 'saleInvoiceAdd') {
                params.goldenTaxType = '004';
              }
              if (this.invoiceInfo.businessType == '01' && this.$route.name == 'saleInvoiceAdd') {
                params.goldenTaxType = '';
              }
              this.$refs.rateInfo.setInit(params);
            });

          // 行信息数据
          // invoiceUnit
          // invoiceAmount

          this.$refs.rowInfo.tableData =
            params.financeSalesInvoiceDetailLsit?.map((item) => {
              console.log(
                item,
                '===========?',
                item.invoiceUnitPrice,
                item.invoiceUnit,
                item.invoiceAmount
              );
              return {
                ...item,
                invoiceUnitPrice:
                  params.businessType == '01'
                    ? (item.invoiceUnitPrice ? item.invoiceUnitPrice : item.invoiceAmount) /
                      item.invoiceQuantity
                    : item.invoiceAmount / item.invoiceQuantity, // 默认为1的开票数量
              };
            }) || [];
          this.$refs.glodenInfo.tableData = params.invoiceInfos || [];
          if (
            ['物贸', '多式联运'].includes(this.userInfo.businessGroup) &&
            params.financeSalesInvoiceDetailLsit != null &&
            params.financeSalesInvoiceDetailLsit.length > 0
          ) {
            this.currentRowInfo = params.financeSalesInvoiceDetailLsit[0];
            this.$refs.rowInfo.$refs.ruleTable.setCurrentRow(
              params.financeSalesInvoiceDetailLsit[0]
            );
          }
        }
      }
    },
    methods: {
      confirm(file) {
        if (file && file.length) {
          let attachmentIdList = this.attachmentList.map((item) => item.attachmentId);
          file.forEach((item) => {
            if (!attachmentIdList.includes(item.attachmentId)) {
              this.attachmentList.push(item);
            }
          });
        }
      },
      viewContractFile() {
        let data = this.$refs.rowInfo.getTableData();
        let dataList = [];
        console.log('合同列表', data);
        if (data && Array.isArray(data) && data.length) {
          dataList = data?.map((item) => item.receivableSettlementNo);
        }
        this.$refs.selectContractFileDialogRef?.openDialog('RECEIVABLE_SETTLEMENT', dataList);
      },
      // rowInfo.vue删除的时候
      deleteRowInfoHandler() {
        this.selectRowList = [];
        this.clearStatementDetailTable = true;
        this.currentRowInfo = {};
        this.rowInfoTableData = this.$refs.rowInfo.tableData;
      },
      clearStatementDetailTableHandler(tableData) {
        this.selectRowList = [];
        this.clearStatementDetailTable = true;
        // setTimeout(() => {
        //   this.rowInfoTableData = this.$refs.rowInfo.tableData;
        // }, 1000);
        this.rowInfoTableData = tableData;
        console.log(this.rowInfoTableData, '111');
      },
      selectionChanged(row) {
        this.selectRowList = row;
      },
      isTableDataHandler(flag) {
        console.log(flag, '监听11');
        this.isDisabledRowDeleteBtn = flag;
      },
      // 删除重新计算上面表格数据
      deleteRowHandler(tableData, isDeleteData = true, deleteReceivableSettlementLineId = []) {
        console.log(tableData, '删除数据', this.selectRowList);
        // tableData表格数据根据receivableSettlementLineId组成map对象
        const receivableSettlementLineIdMap = _.groupBy(tableData, 'receivableSettlementLineId');
        // 上面表格选中的
        const selectRowIdList = this.selectRowList.map(
          (item) => item.receivableSettlementLineId + ''
        );
        const lastSelectedRowId = tableData.map((item) => item.receivableSettlementLineId + '');
        const result = [];
        console.log(this.rowInfoTableData, '创建的时候');
        // TODO 需要区分创建和编辑的时候,创建的时候
        if (this.$route.name == 'saleInvoiceAdd') {
          console.log('新增的时候', this.$refs.rowInfo.getTableData()); // this.$refs.rowInfo.tableData
          for (const item of this.$refs.rowInfo.getTableData()) {
            // 剩下的包括了当前的id的时候
            if (lastSelectedRowId.includes(item.receivableSettlementLineId + '')) {
              console.log('新增进来了1');
              const currentList =
                receivableSettlementLineIdMap[item.receivableSettlementLineId] || [];
              const settlementQuantity = currentList.reduce(
                (pre, cur) => pre + +(cur.settlementQuantity ? cur.settlementQuantity : 0),
                0
              );
              const originalAmount = currentList.reduce(
                (pre, cur) => pre + +(cur.originalAmount ? cur.originalAmount : 0),
                0
              );
              // vue去替换数据
              result.push({
                ...item,
                settlementQuantity,
                invoiceQuantity: settlementQuantity,
                invoiceAmount: originalAmount,
                invoiceUnitPrice: (originalAmount / settlementQuantity).toFixed(8),
                excludedTaxAmount: this.replaceZeroStr(originalAmount / (1 + item.taxRate)),
                taxAmount:
                  originalAmount - this.replaceZeroStr(originalAmount / (1 + item.taxRate)),
                invoiceAccountedAmount: originalAmount * item.taxRate,
                excludedTaxAccountedAmount:
                  this.replaceZeroStr(originalAmount / (1 + item.taxRate)) * item.taxRate,
                taxAccountedAmount:
                  (originalAmount - this.replaceZeroStr(originalAmount / (1 + item.taxRate))) *
                  item.taxRate,
              });
              this.$refs.rowInfo.tableData = result;
              this.calTotal(true);
            } else {
              console.log('新增进来了2');
              if (isDeleteData) {
                // 直接删除这行
                console.log(selectRowIdList, item.receivableSettlementLineId + '', '直接删除');
                if (!selectRowIdList.includes(item.receivableSettlementLineId + '')) {
                  result.push(item);
                }
              } else {
                result.push(item);
              }
              this.$refs.rowInfo.tableData = result;
              this.calTotal(true);
            }
          }
        } else {
          for (const item of this.$refs.rowInfo.getTableData()) {
            // 直接去除不存在的id

            const currentList =
              receivableSettlementLineIdMap[item.receivableSettlementLineId] || [];
            const settlementQuantity = currentList.reduce(
              (pre, cur) => pre + +(cur.settlementQuantity ? cur.settlementQuantity : 0),
              0
            );
            const originalAmount = currentList.reduce(
              (pre, cur) => pre + +(cur.originalAmount ? cur.originalAmount : 0),
              0
            );
            if (isDeleteData) {
              console.log(
                '修改的时候同步数据',
                selectRowIdList,
                '选中的',
                lastSelectedRowId,
                '最后表格的(明细中)',
                item.receivableSettlementLineId,
                '当前的循环'
              );
              if (
                selectRowIdList.includes(item.receivableSettlementLineId + '') &&
                lastSelectedRowId.includes(item.receivableSettlementLineId + '')
              ) {
                console.log(this.rowInfoTableData, '11111');
                const index = this.rowInfoTableData.findIndex((it) => {
                  console.log(
                    it.receivableSettlementLineId,
                    item.receivableSettlementLineId,
                    '---------111--->>'
                  );
                  return it.receivableSettlementLineId == item.receivableSettlementLineId;
                });
                console.log(index, '--找到-->>>');
                if (index >= 0) {
                  this.rowInfoTableData.splice(index, 1, {
                    ...item,
                    settlementQuantity,
                    invoiceQuantity: settlementQuantity,
                    invoiceAmount: originalAmount,
                    invoiceUnitPrice: (originalAmount / settlementQuantity).toFixed(8),
                    excludedTaxAmount: this.replaceZeroStr(originalAmount / (1 + item.taxRate)),
                    taxAmount:
                      originalAmount - this.replaceZeroStr(originalAmount / (1 + item.taxRate)),
                    invoiceAccountedAmount: originalAmount * item.taxRate,
                    excludedTaxAccountedAmount:
                      this.replaceZeroStr(originalAmount / (1 + item.taxRate)) * item.taxRate,
                    taxAccountedAmount:
                      (originalAmount - this.replaceZeroStr(originalAmount / (1 + item.taxRate))) *
                      item.taxRate,
                  });
                  this.$refs.rowInfo.tableData = this.rowInfoTableData;
                  this.calTotal(true);
                }
              } else {
                // 需要删除操作
                console.log('需要删除', deleteReceivableSettlementLineId);
                for (const item1 of deleteReceivableSettlementLineId) {
                  const index = this.rowInfoTableData.findIndex((it) => {
                    return it.receivableSettlementLineId == item1;
                  });
                  console.log(index, '--找到-->>>');
                  if (index >= 0) {
                    this.rowInfoTableData.splice(index, 1);
                  }
                  this.$refs.rowInfo.tableData = this.rowInfoTableData;
                  this.calTotal(true);
                }
              }
            } else {
              console.log('修改的时候不同步数据');
              const index = this.rowInfoTableData.findIndex((it) => {
                console.log(it.receivableSettlementLineId, item.receivableSettlementLineId);
                return it.receivableSettlementLineId == item.receivableSettlementLineId;
              });
              console.log(index, '---->>>');
              if (index >= 0) {
                this.rowInfoTableData.splice(index, 1, {
                  ...item,
                  settlementQuantity,
                  invoiceQuantity: settlementQuantity,
                  invoiceAmount: originalAmount,
                  invoiceUnitPrice: (originalAmount / settlementQuantity).toFixed(8),
                  excludedTaxAmount: this.replaceZeroStr(originalAmount / (1 + item.taxRate)),
                  taxAmount:
                    originalAmount - this.replaceZeroStr(originalAmount / (1 + item.taxRate)),
                  invoiceAccountedAmount: originalAmount * item.taxRate,
                  excludedTaxAccountedAmount:
                    this.replaceZeroStr(originalAmount / (1 + item.taxRate)) * item.taxRate,
                  taxAccountedAmount:
                    (originalAmount - this.replaceZeroStr(originalAmount / (1 + item.taxRate))) *
                    item.taxRate,
                });
                this.$refs.rowInfo.tableData = this.rowInfoTableData;
                this.calTotal(true);
              }
            }
          }
        }
      },
      // 撤回审批
      withdrawApprovalHandler() {
        this.loading.startLoading();
        this.$axios
          .post('/financial/financeSalesInvoice/batchWithdrawOA', {
            ids: [this.$route.query.id],
            oaId: this.userInfo.oaId,
          })
          .then((res) => {
            const { code, msg } = res.data;
            this.loading.endLoading();
            if (code == 0) {
              this.$message.success('撤回成功');
              // TODO
              // this.$router.go(-1);
              this.$store.dispatch('tagsView/delView', {
                path: '/saleInvoice/detail',
                name: 'saleInvoiceDetail',
                meta: {
                  keepAlive: false,
                  title: '',
                },
                query: {},
              });
              this.$router.push({ path: '/saleInvoice/list' });
            } else {
              this.$message.error(msg);
            }
          })
          .catch(() => {
            this.loading.endLoading();
          });
      },
      // 根据结算单号获取附件信息
      async setSettlementNo(val) {
        console.log('获取附件');
        let settlementNoList = [...new Set(val)];
        console.log('new Set([...val])', [...new Set(val)], settlementNoList.length);
        if (settlementNoList.length) {
          const { data } = await this.$axios.post(API.QUERY_FILELIST, settlementNoList);
          console.log('data,', data);
          if (data.code == 0) {
            this.$refs.fileTableRef.fullTableData(data.data);
            // this.attachmentList = data.data;
          }
        } else {
          this.$refs.fileTableRef.fullTableData([]);
          // this.attachmentList = [];
        }
        this.$nextTick(() => {
          this.$forceUpdate();
        });
        console.log('this.attachmentList', this.attachmentList);
      },
      changeBusinessTypeHandler(val) {
        console.log(val, '1111');
        this.currentSettlementBusinessType = val;
      },
      // 默认根据客户取主数据合作伙伴的字段值
      async setRateInfo(info) {
        console.log(info, '修改客户');

        // console.log("传值成功！！！");
        // console.log(this.$refs);
        // console.log(info);
        // let rateInfo = this.$refs.rateInfo.formData;
        // this.$refs.rateInfo.formData = { rateInfo, ...this.$refs.invoiceInfo.formData };
        this.$refs.rateInfo.formData.openBankName = info.invoiceBankName || '';
        this.$refs.rateInfo.formData.openBankCode = info.openBankCode || '';
        this.$refs.rateInfo.formData.bankAccount = info.invoiceBankAccount || '';
        this.$refs.rateInfo.formData.partnerAddress = info.invoiceAddress || '';
        // 业务类别为多式联运时，默认增值税发票类型为“纸质专用发票”
        if (this.invoiceInfo.businessType != '02') {
          this.$refs.rateInfo.formData.goldenTaxType = info.taxType || '';
        }
        // 业务类别为贸易时，不设置增值税发票类型默认值
        if (this.invoiceInfo.businessType == '01') {
          this.$refs.rateInfo.formData.goldenTaxType = '';
        }
        // this.$refs.rateInfo.formData.goldenTaxType = info.taxType || '';
        this.$refs.rateInfo.formData.partnerPhone = info.invoicePhone || '';
        this.$refs.rateInfo.formData.ifPersonalPartner = info.ifPersonalPartner || '';
        this.$refs.rateInfo.formData.invoiceProperty = info.ifPersonalPartner; // 是否为个人1是个人0是企业
        await this.getAllMobileAndEmail(info.partnerCode, this.invoiceInfo.invoiceDepartmentNo);
        this.$refs.rateInfo.formData.partnerEmail = info.partnerEmail || this.emailList[0]?.value;
        this.$refs.rateInfo.formData.mobilePhone = info.mobilePhone || this.mobileList[0]?.value;
        if (info.ifPersonalPartner == 1) {
          this.$refs.rateInfo.formData.creditCode = info.identityNo || info.creditCode;
        } else {
          this.$refs.rateInfo.formData.creditCode = info.creditCode || '';
        }
      },
      // 是个人的时候获取手机号码和邮箱
      async getAllMobileAndEmail(partnerCode, invoiceDepartmentNo) {
        const { data } = await this.$axios.get(
          `${supplierDeliveryOrderApi.GET_PARTNER_PERSON}?partnerCode=${partnerCode}&departmentCode=${invoiceDepartmentNo}`
        );

        console.log(data, '数据');
        if (data.code == 0) {
          this.mobileList = data.data.map((item) => {
            return {
              label: item.mobilePhone,
              value: item.mobilePhone,
            };
          });
          this.emailList = data.data.map((item) => {
            return {
              label: item.email,
              value: item.email,
            };
          });
        } else {
          console.log('根据信息获取手机号码和邮箱失败');
        }
      },
      //获取发票详情
      getDetail() {
        if (this.invoiceInfo.id) {
          this.$axios.get(API.GET_DETAIL, { id: this.invoiceInfo.id }).then((res) => {
            console.log(JSON.stringify(res));
            if (res.data.code == 0) {
              const data = res.data.data;
              // 给发票消息赋值
              this.invoiceInfo = Object.assign(this.invoiceInfo, data);
              this.selectRowList = data.financeSalesInvoiceDetailLsit;
              this.$refs.invoiceInfo.getDetail(this.invoiceInfo);
              this.$refs.invoiceInfo.formData.performancePeriod = data.performancePeriod; //天数
              this.$refs.invoiceInfo.formData.productType = data.productType; //天数
              this.$refs.rateInfo.formData.openBankCode = data.openBankCode;
              this.$refs.rateInfo.formData.openBankName = data.openBankName;
              this.$refs.rateInfo.formData.bankAccount = data.bankAccount;

              this.$refs.rateInfo.formData.partnerAddress = data.partnerAddress;
              this.$refs.rateInfo.formData.goldenTaxType = data.goldenTaxType;
              this.$refs.rateInfo.formData.goldenTaxDate = data.goldenTaxDate;
              this.$refs.rateInfo.formData.partnerPhone = data.partnerPhone;

              // 新加字段
              this.$refs.rateInfo.formData.ifPersonalPartner = data.invoiceProperty;
              this.$refs.rateInfo.formData.partnerEmail = data.partnerEmail;
              this.$refs.rateInfo.formData.partnerPhone = data.partnerPhone;
              this.$refs.rateInfo.formData.invoiceProperty = data.invoiceProperty;
              this.$refs.rowInfo.tableData = data.financeSalesInvoiceDetailLsit || []; // 给结算行赋值
              // 获取详情 因为有编辑按钮控制 行删除按钮不可点击（默认为可点击）
              this.isDisabledRowDeleteBtn = true;

              if (
                ['物贸', '多式联运'].includes(this.userInfo.businessGroup) &&
                data.financeSalesInvoiceDetailLsit != null &&
                data.financeSalesInvoiceDetailLsit.length > 0
              ) {
                this.currentRowInfo = data.financeSalesInvoiceDetailLsit[0];
                this.$refs.rowInfo.$refs.ruleTable.setCurrentRow(
                  data.financeSalesInvoiceDetailLsit[0]
                );
              }
              this.rowInfoTableData = data.financeSalesInvoiceDetailLsit || []; // 临时赋值
              console.log(this.rowInfoTableData, '拉取数据');
              if (data.invoiceProperty == '1') {
                this.$refs.rateInfo.formData.creditCode = data.identityNo || data.creditCode;
              } else {
                this.$refs.rateInfo.formData.creditCode = data.creditCode;
              }
              this.getAllMobileAndEmail(data.partnerCode, data.invoiceDepartmentNo).then(() => {
                this.$refs.rateInfo.formData.partnerEmail = data.partnerEmail || '';
                this.$refs.rateInfo.formData.mobilePhone = data.mobilePhone || '';
              });
              this.currentSettlementBusinessType = data.businessType;
              this.$refs.glodenInfo.tableData = data.invoiceInfos || [];
              // 获取凭证ID 获取凭证列表
              this.entityDataId = data.id;
              // this.getAccountEntry();
              this.attachmentList = res.data.data.returnAttachmentList || [];
            } else {
              this.$alert(res.data.msg);
            }
          });
        }
      },
      // 校验发票信息
      async validateInvoice() {
        let invoiceFlag = await this.$refs.invoiceInfo.getVal();
        let rateFlag = await this.$refs.rateInfo.getVal();
        return new Promise((resolve) => {
          invoiceFlag && rateFlag ? resolve(true) : resolve(false);
        });
      },
      // 发票信息变更
      updateInvoice(invoiceInfo) {
        console.log(invoiceInfo, '发票信息');
        this.invoiceInfo = { ...this.invoiceInfo, ...invoiceInfo };
      },

      // 重置行信息
      resetRowInfo() {
        this.$refs.rowInfo.tableData = [];
      },

      //更新附件列表
      uploadList(value) {
        console.log(value, '???');
        this.attachmentList = [];
        if (value.length) {
          value.map((item) => {
            this.attachmentList.push({
              ...item,
            });
          });
        }
      },
      // 首页统计合计
      calTotal: XEUtils.debounce(function (data) {
        console.log(data, '111-->>?');
        if (data) {
          let total = this.$refs.rowInfo.calTotal();
          XEUtils.objectEach(total, (item, key) => {
            // 对象迭代器，只能用于遍历对象，性能高于 each
            this.$refs.invoiceInfo.formData[key] = item;
          });
        }
      }, 500),
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
        });
      },
      commit() {},
      // 更新付款信息
      update() {
        this.payInfoList = [];
      },
      // 更新付款信息
      updatePayment() {
        this.payList = [];
      },
      //匹配采购合同
      selectContract(row, index) {
        console.log(row, index);
        // const rows = this.$refs['invoiceLineInfo'].$refs['xTable'].getTableData().fullData;
      },
      // 提交
      async submit(cancelValidate) {
        // 判断金税发票-增值税发票类型是否为空
        let goldenTaxType = this.$refs.rateInfo.formData.goldenTaxType;
        if (!goldenTaxType) {
          this.$message({
            showClose: true,
            message: '请选择增值税发票类型',
            type: 'error',
          });
          return;
        }
        // this.$refs.rateInfo.formData.ifPersonalPartner
        /**
         * 提交的时候根据判断
         * 1.如果是企业的时候(ifPersonalPartner==0),发票种类为:026：电子普通发票”或者是“028：电子专用发票
         * 的时候，手机号码或者邮箱必要有一个
         * 2.对于个人来说发票种类为:028：电子专用发票”或者是“004：纸质专用发票 不能提交
         * 3.业务类别为贸易的时候，且商品类型为开票项的时候必须校验商品编码
         */
        const ifPersonalPartner = this.$refs.rateInfo.formData.ifPersonalPartner;
        const mobilePhone = this.$refs.rateInfo.formData.mobilePhone;
        const partnerEmail = this.$refs.rateInfo.formData.partnerEmail;
        if (ifPersonalPartner) {
          // 企业的时候
          if (['026', '028'].includes(goldenTaxType) && !mobilePhone && !partnerEmail) {
            this.$message.error('移动电话或者邮箱必须有一个');
            return;
          }
        } else {
          // 个人的时候
          if (['028', '004'].includes(goldenTaxType)) {
            this.$message.error('不能提交');
            return;
          }
        }

        const p1 = await this.validateInvoice();
        if (!p1) return;
        this.invoiceInfo = { ...this.$refs.invoiceInfo.formData };
        this.$refs['rowInfo'].$refs['ruleTable'].validate(async (valid) => {
          if (valid) {
            const attachmentList = this.$refs.fileTableRef?.getTableData();
            const financeSalesInvoiceDetailLsit =
              this.$refs.rowInfo.$refs['ruleTable'].getTableData().fullData;
            // 业务类别为贸易的时候，且商品类型为开票项的时候必须校验商品编码
            if (this.invoiceInfo.businessType == '01' && this.invoiceInfo.productType == '1') {
              const isValidProductNo = financeSalesInvoiceDetailLsit.every((item) =>
                Boolean(item.productNo)
              );
              if (!isValidProductNo) {
                this.$message.error('当前是贸易且商品类型为开票项的时候商品编码不能为空');
                return;
              }
            }
            // 当是费用项目的时候
            if (this.invoiceInfo.productType == '1') {
              const isValidProductNo = financeSalesInvoiceDetailLsit.every((item) =>
                Boolean(item.expenseItem)
              );
              if (!isValidProductNo && this.userInfo.businessGroup != '多式联运') {
                this.$message.error('费用项目不能为空');
                return;
              }
            }
            if (['物贸', '多式联运'].includes(this.userInfo.businessGroup)) {
              let checkLinesRefStatus = await this.$refs?.rowDetailTableRef?.validAllEvent(true);
              if (!checkLinesRefStatus) {
                const index = financeSalesInvoiceDetailLsit.findIndex(
                  (item) => item.detailExtendList == null || item.detailExtendList.length == 0
                );
                // 如果其中一条有，就不会返回-1，全部都没有返回-1
                if (index != -1) {
                  return this.$message.error('每个行信息至少包含一个明细行！');
                }
              } else {
                return this.$message.error('请补充明细');
              }
              let checkedAmount = true;
              financeSalesInvoiceDetailLsit.forEach((item) => {
                item.detailExtend = null;
                let sum = XEUtils.calSum(item.detailExtendList, 'invoiceAmount');
                if (sum > item.invoiceAmount) {
                  return (checkedAmount = false);
                }
                if (item.detailExtendList) {
                  for (let i = 0; i < item.detailExtendList.length; i++) {
                    const element = item.detailExtendList[i];
                    element.taxAmount = Number(
                      parseFloat(element.invoiceAmount - element.excludedTaxAmount).toFixed(2)
                    );
                    element.invoiceAccountedAmount =
                      element.invoiceAmount * (item.exchangeRate ?? 1);
                    element.excludedTaxAccountedAmount =
                      element.excludedTaxAmount * (item.exchangeRate ?? 1);
                    element.taxAccountedAmount = element.taxAmount * (item.exchangeRate ?? 1);
                  }
                }
              });
              if (!checkedAmount) {
                return this.$message.error(
                  '明细含税金额总和不能大于行信息含税总金额，请检查数据！'
                );
              }
            }
            const financeSalesInvoiceSplitDetailLsit = this.$refs.statementDetailTableRef
              ? this.$refs.statementDetailTableRef.tableData.map((item) => {
                  console.log(item, '???');
                  return {
                    // ...item,
                    id: item.salesInvoiceSplitDetailId,
                    invoiceId: this.invoiceInfo.id,
                    invoiceCode: this.invoiceInfo.invoiceNum,
                    invoiceDepartmentCode: item.departmentCode,
                    invoiceDepartmentName: item.departmentName,
                    productNo: item.productCode,
                    productDesc: item.productName,
                    invoiceUnitPrice: item.originalPrice,
                    invoiceQuantity: item.settlementQuantity,
                    invoiceUnit: item.unitName,
                    invoiceAmount: item.originalAmount,
                    invoiceAccountedAmount: item.domesticAmount,
                    currency: item.currencyCode,
                    exchangeRate: item.exchangeRate,
                    receivableSettlementLineId: item.receivableSettlementLineId,
                    receivableSettlementLineDetailId: item.id,
                    receivableSettlementNo: item.receivableSettlementNo,
                    settlementQuantity: item.settlementQuantity,
                    invoiceDesc: '',
                    vehicleNo: item.vehicleNo,
                    deliveryDate: item.deliveryDate,
                  };
                })
              : [];
            // if (
            //   !financeSalesInvoiceSplitDetailLsit.length &&
            //   this.userInfo.businessGroup == '城矿'
            // ) {
            //   this.$message.error('请补充结算明细');
            //   return;
            // }
            let params = {
              ...this.$refs.invoiceInfo.formData,
              ...this.$refs.rateInfo.formData,
              financeSalesInvoiceDetailLsit, // 表格数据
              invoiceSource: this.invoiceInfo.invoiceSource || 3, //1销售提单,2销售退货,3手写
              saveUpdate: 2,
              id: this.invoiceInfo.id || null,
              lastModifiedBy: this.userInfo.userCode,
              oaId: JSON.parse(this.userInfo.companyList).find(
                (it) => it.personCompanyCode == this.userInfo.companyCode
              )?.oaId,
              isSubmit: true,
              cancelValidate,
              financeSalesInvoiceSplitDetailLsit,
              attachmentList: attachmentList,
              businessGroup: this.userInfo.businessGroup,
              returnAttachmentList: attachmentList, // 强制重置值
            };
            if (params.invoiceType == 'creditMemo' && params.invoiceAmount >= 0) {
              this.$message({
                showClose: true,
                message: this.$t('addInvoice.warnInfo.needLowZero'),
                type: 'error',
              });
              return;
            } else if (params.invoiceType == 'invoice' && params.invoiceAmount <= 0) {
              this.$message({
                showClose: true,
                message: this.$t('addInvoice.warnInfo.needOverZero'),
                type: 'error',
              });
              return;
            }
            params = this.$baseRequest.assignObj(params);
            loading.startLoading();
            this.$axios
              .post(API.ADD_INVOICE, params)
              .then((res) => {
                loading.endLoading();
                if (res.data.code === 0) {
                  this.$message({
                    showClose: true,
                    message: this.$t('message.success'),
                    type: 'success',
                  });
                  if (this.isHnFlag && this.invoiceInfo.invoiceSource == '1') {
                    this.backContract();
                  } else {
                    this.goBack();
                  }
                } else if (res.data.code === 10) {
                  this.$reportErrors({
                    msg: res.data.msg,
                    code: res.data.code,
                    callback: () => {
                      //确认提交，cancelValidate传值true取消校验
                      params.cancelValidate = true;
                      this.submit(true);
                    },
                  });
                } else {
                  this.$message({ showClose: true, message: res.data.msg, type: 'error' });
                }
              })
              .catch(() => loading.endLoading());
          } else {
            this.$message({
              showClose: true,
              message: '请检查行信息',
              type: 'error',
            });
          }
        });
      },
      // 保存
      async save() {
        const p1 = await this.validateInvoice();
        if (!p1) return;
        this.$refs['rowInfo'].$refs['ruleTable'].validate(async (valid) => {
          if (valid) {
            const attachmentList = this.$refs.fileTableRef?.getTableData();
            const financeSalesInvoiceSplitDetailLsit = this.$refs.statementDetailTableRef
              ? this.$refs.statementDetailTableRef.tableData.map((item) => {
                  console.log(item, '???');
                  return {
                    // ...item,
                    id: item.salesInvoiceSplitDetailId,
                    invoiceId: this.invoiceInfo.id,
                    invoiceCode: this.invoiceInfo.invoiceNum,
                    invoiceDepartmentCode: item.departmentCode,
                    invoiceDepartmentName: item.departmentName,
                    productNo: item.productCode,
                    productDesc: item.productName,
                    invoiceUnitPrice: item.originalPrice,
                    invoiceQuantity: item.settlementQuantity,
                    invoiceUnit: item.unit,
                    invoiceAmount: item.originalAmount,
                    invoiceAccountedAmount: item.domesticAmount,
                    currency: item.currencyCode,
                    exchangeRate: item.exchangeRate,
                    receivableSettlementLineId: item.receivableSettlementLineId,
                    receivableSettlementLineDetailId: item.id,
                    receivableSettlementNo: item.receivableSettlementNo,
                    settlementQuantity: item.settlementQuantity,
                    invoiceDesc: '',
                    vehicleNo: item.vehicleNo,
                    deliveryDate: item.deliveryDate,
                  };
                })
              : [];
            // if (
            //   !financeSalesInvoiceSplitDetailLsit.length &&
            //   this.userInfo.businessGroup == '城矿'
            // ) {
            //   this.$message.error('请补充结算明细');
            //   return;
            // }
            let params = {
              ...this.$refs.invoiceInfo.formData,
              ...this.$refs.rateInfo.formData,
              financeSalesInvoiceDetailLsit:
                this.$refs.rowInfo.$refs['ruleTable'].getTableData().fullData,
              saveUpdate: 1,
              invoiceSource: this.invoiceInfo.invoiceSource || 3, //1销售提单,2销售退货,3手写
              isSubmit: false,
              attachmentList: attachmentList,
              returnAttachmentList: attachmentList, // 强制重置值
              businessGroup: this.userInfo.businessGroup,
              financeSalesInvoiceSplitDetailLsit,
            };
            if (params.financeSalesInvoiceDetailLsit.length == 0) {
              this.$message({
                showClose: true,
                message: '请填写行信息',
                type: 'error',
              });
              return;
            }
            if (['物贸', '多式联运'].includes(this.userInfo.businessGroup)) {
              let checkLinesRefStatus = await this.$refs?.rowDetailTableRef?.validAllEvent(true);
              console.log(
                'params.financeSalesInvoiceDetailLsit',
                params.financeSalesInvoiceDetailLsit
              );
              if (!checkLinesRefStatus) {
                const index = params.financeSalesInvoiceDetailLsit.findIndex(
                  (item) => item.detailExtendList == null || item.detailExtendList.length == 0
                );
                if (index != -1) {
                  return this.$message.error('每个行信息至少包含一个明细行！');
                }
              } else {
                return this.$message.error('请补充明细');
              }
              let checkedAmount = true;
              params.financeSalesInvoiceDetailLsit.forEach((item) => {
                item.detailExtend = null;
                let sum = XEUtils.calSum(item.detailExtendList, 'invoiceAmount');
                if (sum > item.invoiceAmount) {
                  return (checkedAmount = false);
                }
                if (item.detailExtendList) {
                  for (let i = 0; i < item.detailExtendList.length; i++) {
                    const element = item.detailExtendList[i];
                    if (element.taxRate == '0') {
                      element.taxRate = '0.00';
                    }
                    element.taxAmount = Number(
                      parseFloat(element.invoiceAmount - element.excludedTaxAmount).toFixed(2)
                    );
                    element.invoiceAccountedAmount =
                      element.invoiceAmount * (item.exchangeRate ?? 1);
                    element.excludedTaxAccountedAmount =
                      element.excludedTaxAmount * (item.exchangeRate ?? 1);
                    element.taxAccountedAmount = element.taxAmount * (item.exchangeRate ?? 1);
                  }
                }
              });
              if (!checkedAmount) {
                return this.$message.error(
                  '明细含税金额总和不能大于行信息含税总金额，请检查数据！'
                );
              }
            }
            // console.log(this.$refs.invoiceInfo.formData);
            // console.log(this.$refs.rateInfo.formData);
            if (params.invoiceType == 'creditMemo' && params.invoiceAmount >= 0) {
              this.$message({
                showClose: true,
                message: this.$t('addInvoice.warnInfo.needLowZero'),
                type: 'error',
              });
              return;
            } else if (params.invoiceType == 'invoice' && params.invoiceAmount <= 0) {
              this.$message({
                showClose: true,
                message: this.$t('addInvoice.warnInfo.needOverZero'),
                type: 'error',
              });
              return;
            }
            params.financeSalesInvoiceDetailLsit.map((item, index) => {
              item['invoiceDetailCode'] = index + 1;
              item = this.$baseRequest.assignObj(item);
              return item;
            });
            params = this.$baseRequest.assignObj(params);
            loading.startLoading();
            this.$axios
              .post(API.ADD_INVOICE, params)
              .then((res) => {
                loading.endLoading();
                if (res.data.code === 0) {
                  this.$message({ showClose: true, message: res.data.msg, type: 'success' });
                  const data = res.data.data;
                  // data.exchangeRate = data.exchangeRate;
                  if (!data.invoiceStatus) data.invoiceStatus = '';
                  this.$refs.invoiceInfo.formData = data;
                  this.invoiceInfo = data;
                  this.$refs.rowInfo.tableData = data.financeSalesInvoiceDetailLsit;
                  if (
                    ['物贸', '多式联运'].includes(this.userInfo.businessGroup) &&
                    data.financeSalesInvoiceDetailLsit != null &&
                    data.financeSalesInvoiceDetailLsit.length > 0
                  ) {
                    this.currentRowInfo = data.financeSalesInvoiceDetailLsit[0];
                    this.$refs.rowInfo.$refs.ruleTable.setCurrentRow(
                      data.financeSalesInvoiceDetailLsit[0]
                    );
                  }
                  if (this.invoiceInfo.invoiceStatus == 'saved') {
                    this.canEdit = false;
                  }
                } else {
                  this.$message({ showClose: true, message: res.data.msg, type: 'error' });
                }
              })
              .catch(() => loading.endLoading());
          } else {
            this.$message({
              showClose: true,
              message: '请检查行信息',
              type: 'error',
            });
          }
        });
      },

      // 编辑
      edit() {
        this.canEdit = true;
      },
      // 撤回 只有已提交、暂挂状态下才能点击该按钮
      withdraw() {
        this.$confirmAction(
          this.$t('addInvoice.confirm.withdraw.title'),
          this.$t('addInvoice.confirm.withdraw.content')
        )
          .then(() => {
            loading.startLoading();
            this.$axios.post(API.BATCH_WITHDRAW, { ids: [this.invoiceInfo.id] }).then((res) => {
              loading.endLoading();
              if (res.data.code === 0) {
                this.$message({
                  showClose: true,
                  type: 'success',
                  message: this.$t('message.success'),
                });
                this.goBack();
              } else {
                this.$message({ showClose: true, message: res.data.msg, type: 'error' });
              }
            });
          })
          .catch(() => {
            loading.endLoading();
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },

      // 退回 只有“已提交”、“暂挂”状态下的数据才能点击退回按钮 权限划分：财务人员按钮
      returnRecords() {
        this.$confirmAction(
          this.$t('addInvoice.confirm.returned.title'),
          this.$t('addInvoice.confirm.returned.content')
        )
          .then(() => {
            loading.startLoading();
            this.$axios.post(API.BATCH_RETURN, { ids: [this.invoiceInfo.id] }).then((res) => {
              loading.endLoading();
              if (res.data.code === 0) {
                this.$message({
                  showClose: true,
                  type: 'success',
                  message: this.$t('message.success'),
                });
                this.goBack();
              } else {
                this.$message({ showClose: true, message: res.data.msg, type: 'error' });
              }
            });
          })
          .catch(() => {
            loading.endLoading();
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 删除
      deleteRecord() {
        this.$confirmAction()
          .then(() => {
            loading.startLoading();
            this.$axios.post(API.DELETE_DATA, { ids: [this.invoiceInfo.id] }).then((res) => {
              loading.endLoading();
              if (res.data.code === 0) {
                this.$message({ showClose: true, message: this.$t('message.success') });
                this.goBack();
              } else {
                this.$message({ showClose: true, message: res.data.msg, type: 'error' });
              }
            });
          })
          .catch(() => {
            loading.endLoading();
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      generatePaymentDocument() {
        let path = {
          path: '/payment/paymentApplyAdd',
          name: 'paymentApplyAdd',
          meta: {
            title: '付款申请单创建',
          },
          query: {
            invoiceCode: this.feeInfo.invoiceCode,
            payableInvoiceCompanyCode: this.feeInfo.payableInvoiceCompanyCode,
            invoiceUnitNo: this.feeInfo.invoiceUnitNo,
            invoiceUnitName: this.feeInfo.invoiceUnitName,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 返回
      goBack() {
        let pathList = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: {
              keepAlive: true,
              title: this.$t('currenciesAndCalendar.addCurrencies.addCurrencies'),
            },
          },
          toPath: {
            path: '/saleInvoice/list',
            name: 'saleInvoiceList',
            meta: {
              keepAlive: false,
              title: this.$t('currenciesAndCalendar.addCurrencies.queryCurrencies'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },

      // 返回合同
      backContract() {
        this.$axios
          .post(ORDER_API.GET_ORDER_DETAIL_API, {
            contractNo: this.invoiceInfo.contractNo,
            dataGroup: 'hn',
          })
          .then((res) => {
            if (res.data.code === 0) {
              let pathList = {
                fromPath: {
                  path: this.$route.path,
                  name: this.$route.name,
                  meta: {
                    keepAlive: true,
                    title: this.$t('currenciesAndCalendar.addCurrencies.addCurrencies'),
                  },
                },
                toPath: {
                  path: '/salePurchaseHN/singleSaleEdit',
                  name: 'singleSaleEditHN',
                  meta: {
                    keepAlive: false,
                    title: this.$t('salePurchase.message.singleSalesContractEdit'),
                  },
                  query: {
                    id: res.data.data.id,
                    type: 'HT07',
                    contractNo: this.invoiceInfo.contractNo,
                    contractCategory: 'sales',
                    isEdit: true,
                  },
                },
              };
              this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
                this.$nextTick(() => {
                  this.$router.push(pathList.toPath);
                });
              });
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
      },
      // 打印
      print() {
        this.$refs.printDialog.openDialog(true, this.invoiceInfo.id);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .deliveryOrderTop {
    background-color: #fff;
    margin-bottom: 10px;
    padding: 26px 10px 11px 10px;
  }
</style>
